<template lang="html">
  <div>
    <v-img src="/static/road-train-au-lg.png" contain></v-img>
  </div>
</template>

<script>
import _ from 'lodash';
// import LoadBoards from '@/pages/LoadBoards';
// import LoadsPage from '@/pages/Companies/Loads/LoadsPage';
// import MyAssignedLoads from '@/pages/User/MyAssignedLoads';
import pluginMixin from '@/mixins/pluginMixin';
import { mapGetters, mapState } from 'vuex';
import * as Companies from '@/types/models/company';
import {
  accountHasCreateListingPermission,
  accountHasOfficePermission,
  accountHasAdminPermission,
} from '@/store/permissions';
import { UserRole, UserPerm } from '@/types';
import SessionModal from '@/components/SessionModal.vue';


export default {
  mixins: [
    pluginMixin,
  ],
  components: {
    SessionModal,
  },
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
  },
  computed: {
    ...mapGetters('applications', [
      'signedIn',
    ]),
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapState('companies', {
      company: 'profileCompany',
    }),
    userCompanyAccount() {
      return this.findCompanyAccount()(this.company.id);
    },
  },
  mounted() {
    let route = undefined;
    let companyId = null;

    if (!this.signedIn) {
      // if loadboard plugin is active, go to loadboard
      if (this.isLoadboardEnabled) {
        route = 'load-boards';
      } else {
        // if not, show log in.
      }
    } else {
      const companyAccounts = this.userProfile.companyAccounts || [];

      if (companyAccounts.length === 0) {
        // not a part of any company
        if (this.userProfile.driverProfile) {
          // if no company, go to my loads if a driver
          route = 'my-loads';
        } else {
          // profile page?
          route = 'profile';
        }
      } else {
        const account = companyAccounts[0];
        const permissions = _.get(account, 'companyPermissions') || [];
        companyId = account.companyId;

        if (permissions.length === 0) {
          route = 'my-loads';
        } else {
          route = route || (
            permissions.includes(UserPerm.PERM_ADMIN) ||
            permissions.includes(UserPerm.PERM_OFFICE)
          ) ? 'company.loads.planner' : undefined

          // if only financial, go to transactions
          route = route || permissions.includes(UserPerm.PERM_FINANCIAL) ? 'company.transactions' : undefined

          // if only receiving, go to flight board
          route = route || permissions.includes(UserPerm.PERM_RECEIVING) ? 'company.receiving' : undefined
        }
      }
    }

    if (route) {
      this.$router.push({ name: route, params: { id: companyId} })
    } else {
      // pop the modal login
      // this.$store.dispatch('applications/showSessionModal');
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/LandingPage.vue